import { Box, Modal } from '@mui/material';
import { Button, Grid, Typography } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import Colors from '../theme/colors';

interface AccountBlockedProps {
  open: boolean;
  isRedirectFromBlockedExpiredPage: boolean;
  handleClose: () => void;
}

const style = {
  position: 'absolute',
  top: '35%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 410,
  height: 260,
  backgroundColor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

export const AccountBlocked: React.FC<PropsWithChildren<AccountBlockedProps>> = ({
  open,
  isRedirectFromBlockedExpiredPage,
  handleClose,
}) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <Typography
          id='modal-modal-title'
          variant='h2'
          sx={{
            fontSize: '20px !important',
            fontWeight: '400',
            lineHeight: '28px',
            letterSpacing: '0.15px',
          }}
        >
          {isRedirectFromBlockedExpiredPage ? 'Password link expired' : 'Account locked'}
        </Typography>
        <Grid
          id='modal-modal-description'
          container
          sx={{
            '& .link-text': {
              color: Colors.teal,
              fontWeight: 500,
            },
            gap: '12px',
          }}
        >
          {
            <Typography
              variant='body2'
              sx={{
                fontSize: '14px',
                lineHeight: '20px',
                marginTop: '20px',
                marginBottom: '10px',
                letterSpacing: '0.25px',
              }}
            >
              {isRedirectFromBlockedExpiredPage ? (
                <>
                  The link you are attempting to use has expired (it has been {'>'}24 hours since you received the
                  email). Please contact Karius at{' '}
                  <a href={'tel:8664527487'} className='link-text'>
                    (866) 452-7487
                  </a>
                  {', '}
                  <a href={'mailto:help@kariusdx.com'} className='link-text'>
                    help@kariusdx.com
                  </a>{' '}
                  to get your account unlocked or reset your password. .
                </>
              ) : (
                <>
                  Please check your email for a method to unlock your account, or you can reset your password. If you
                  need assistance, please contact Karius at <br />
                  <a href={'tel:8664527487'} className='link-text'>
                    (866) 452-7487
                  </a>{' '}
                  or{' '}
                  <a href={'mailto:help@kariusdx.com'} className='link-text'>
                    help@kariusdx.com
                  </a>
                  .
                </>
              )}
            </Typography>
          }

          <Grid
            item
            xs={12}
            mt='20px'
            sx={{
              textAlign: 'right',
            }}
          >
            <Button
              color='primary'
              variant={`outlined`}
              sx={{
                borderRadius: '20px',
                marginTop: '5px',
                fontSize: '12px',
                textTransform: 'unset',
                width: '110px',
              }}
              onClick={handleClose}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};
